import {DropDownFilterMobile} from "./DropDownFilterMobile";
import {categoryStore} from "../../../../Stores/CategoryStore";
import {useSearchParams} from "react-router-dom";
import {getUniqueLeafFilters} from "../../../../Utilities/categoryUtils";
import {observer} from "mobx-react-lite";

export const CustomFiltersMobile = observer(() => {
    const [searchParams] = useSearchParams();
    const path = searchParams.get("category")?.split(" > ");

    if (!path?.length)
        return <></>;

    const level = path.reduce((current, name) => {
        const list = Array.isArray(current) ? current : current.children;
        return list.find(item => item.name === name);
    }, categoryStore.categoryTree);

    const filters = [];
    const leafFilters = getUniqueLeafFilters(level);

    Object.entries(leafFilters).forEach(([key, filter]) => {
        if (filter.type === "dropdown") {
            filters.push(
                <DropDownFilterMobile
                    key={`filter_${key}`}
                    filter={filter}
                />
            );
        }
    });

    return filters;
})